import { GlobalConstants } from "../constant/constant";
import { Coordinate, LocationCaptureMethod, PostitionCoords } from "../models/location/location-models";

export function convertAccuracyInMetersToFeet(accuracy: number) {
  return Math.round(accuracy * GlobalConstants.METER_TO_FOOT_CONVERSION_RATE);
}

export function getFormattedCoordinate(coords: PostitionCoords, captureMethod: LocationCaptureMethod): Coordinate {
    return {
      latitude: +coords.latitude.toFixed(GlobalConstants.COORDINATES_PRECISION),
      longitude: +coords.longitude.toFixed(GlobalConstants.COORDINATES_PRECISION),
      accuracy: coords.accuracy ? convertAccuracyInMetersToFeet(coords.accuracy) : null,
      altitude: coords.altitude ? +coords.altitude.toFixed(GlobalConstants.COORDINATES_PRECISION) : null,
      datetime: new Date().toISOString(),
      captureMethod: captureMethod
    };
  }